
import { directive } from "vue-awesome-swiper";
import "swiper/swiper.scss";
import "swiper/components/pagination/pagination.scss";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/effect-coverflow/effect-coverflow.scss";

export default {
  name: "CaraPemesanan",
  directives: {
    swiper: directive,
  },
  scrollToTop: true,
  asyncData(context) {
    // // This what would we do in real project
    // const version = context.query._storyblok || context.isDev ? 'draft' : 'published'
    // const fullSlug = (context.route.path == '/' || context.route.path == '') ? 'home' : context.route.path

    // Load the JSON from the API - loadig the home content (index page)
    return context.app.$storyapi
      .get("cdn/stories/cara-pemesanan-badut-maskot", {
        version: "draft",
      })
      .then((res) => {
        return res.data;
      })
      .catch((res) => {
        if (!res.response) {
          console.error(res);
          context.error({
            statusCode: 404,
            message: "Failed to receive content from API",
          });
        } else {
          console.error(res.response.data);
          context.error({
            statusCode: res.response.status,
            message: res.response.data,
          });
        }
      });
  },
  data() {
    return {
      fotoJadi: [
        "",
        "https://a.storyblok.com/f/118728/1400x1400/af8e956841/kostum-badut-maskot-hm-1.jpg",
        "https://a.storyblok.com/f/118728/1400x1400/db26f4df72/kostum-badut-maskot-hm-2.jpg",
        "https://a.storyblok.com/f/118728/1400x1400/6d3f770b46/kostum-badut-maskot-hm-3.jpg",
      ],
      swiperOption: {
        effect: "coverflow",
        pagination: {
          el: "#swiper-pagination",
          type: "bullets",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        centeredSlides: true,
        grabCursor: true,
        slidesPerView: "auto",
        spaceBetween: 0,
        loop: false,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: false,
        },
        // slidesOffsetBefore: "6",
        mousewheel: {
          invert: false,
          forceToAxis: true,
        },
      },
      story: { content: {} },
    };
  },
  head() {
    return {
      title: this.story.content.meta.title,
      titleTemplate: "%s | INDOMASCOT",
      description: this.story.content.meta.description,
      meta: this.createSEOMeta(
        this.story.content.meta,
        this.story.name,
        this.story.slug
      ),
    };
  },
  mounted() {
    this.$storybridge(() => {
      const storyblokInstance = new StoryblokBridge();

      // Use the input event for instant update of content
      storyblokInstance.on("input", (event) => {
        console.log(this.story.content);
        if (event.story.id === this.story.id) {
          this.story.content = event.story.content;
        }
      });

      // Use the bridge to listen the events
      storyblokInstance.on(["published", "change"], () => {
        // window.location.reload()
        this.$nuxt.$router.go({
          path: this.$nuxt.$router.currentRoute,
          force: true,
        });
      });
    });
  },
  methods: {
    getSidePhotoUrl: function (side) {
      return `/how-to-order/foto-jadi/kostum-badut-maskot-hm-${side}.jpg`;
    },
    getSidePhoto: function (side) {
      return `howToOrderMascotCostumeSteps.step4.${side}`;
    },
  },
};
